const NAO_INICIADA = 'NAO_INICIADA';
const EM_ANDAMENTO = 'EM_ANDAMENTO';
const CONCLUIDA = 'CONCLUIDA';
const ATRASADA = 'ATRASADA';

const isStatusNaoIniciada = (value) => (
  NAO_INICIADA === value
);
const isStatusEmAndamento = (value) => (
  EM_ANDAMENTO === value
);
const isStatusConcluida = (value) => (
  CONCLUIDA === value
);
const isStatusAtrasada = (value) => (
  ATRASADA === value
);

const toTime = (value) => {
  const time = new Date(value).getTime();

  return Number.isNaN(time) ? undefined : time;
};

const getUltimaEtapaConcluida = (etapas) => {
  if (!Array.isArray(etapas)) {
    return undefined;
  }

  return etapas.reduce((ultima, atual) => {
    const dataAtual = atual?.dataConclusao ? toTime(atual?.dataConclusao) : undefined;

    if (dataAtual === undefined) {
      return ultima;
    }

    if (!ultima) {
      return atual;
    }

    const dataUltima = toTime(ultima?.dataConclusao);

    if (dataAtual > dataUltima) {
      return atual;
    }

    if (dataAtual === dataUltima && Number(atual?.id) > Number(ultima?.id)) {
      return atual;
    }

    return ultima;
  }, undefined);
};

const getDescricaoUltimaEtapaConcluida = (etapas) => {
  const etapa = getUltimaEtapaConcluida(etapas);

  return etapa?.description || etapa?.etapa?.description;
};

const EtapaFollowUpUtils = {
  NAO_INICIADA,
  EM_ANDAMENTO,
  CONCLUIDA,
  ATRASADA,
  isStatusNaoIniciada,
  isStatusEmAndamento,
  isStatusConcluida,
  isStatusAtrasada,
  getUltimaEtapaConcluida,
  getDescricaoUltimaEtapaConcluida,
};

export default EtapaFollowUpUtils;
